const LoginOtpForm = function () {
  this.init = function () {
    const form = document.getElementById('kc-otp-login-form');
    form.addEventListener('submit', () => {
      $('#kc-login').prop('disabled', 'true').val($('#kc-login').data('valueProcessing'));
    });
  }
}

const loginOtpForm = new LoginOtpForm();
